module.exports = __webpack_public_path__ + "img/newPaintingPav11m.dfcfce8e.png";